import React, { useState, createContext, useContext } from 'react';
type Language = 'en' | 'ua';
interface Translations {
  [key: string]: string;
}
const translations: Record<Language, Translations> = {
  en: {
    // Nav
    'nav.about': 'About',
    'nav.members': 'Members',
    'nav.projects': 'Projects',
    'nav.events': 'Events',
    'nav.news': 'News',
    'nav.contacts': 'Contacts',
    'nav.join': 'Join',
    // Hero
    'hero.title': 'International IT Cluster',
    'hero.subtitle': 'Hungary & EU countries',
    'hero.desc': 'Uniting tech companies, startups, and educational institutions for joint growth and innovation in the European market.',
    'hero.cta.more': 'Learn More',
    'hero.cta.join': 'Join the Cluster',
    'hero.placeholder': 'Image / Video',
    'hero.stat.companies': 'companies',
    'hero.stat.countries': 'countries',
    'hero.stat.projects': 'projects',
    'hero.stat.events': 'events',
    // About
    'about.title': 'About the Cluster',
    'about.desc': 'We are an international commercial and educational project operating in the Hungarian and EU markets. Our goal is to create a powerful digital platform to present members, initiatives, and collaboration opportunities.',
    'about.p1.title': 'Commercial Activity',
    'about.p1.desc': 'We help members find new clients, partners, and enter new European markets through joint initiatives.',
    'about.p2.title': 'Educational Programs',
    'about.p2.desc': 'We develop talent through cooperation with universities, organizing internships, and specialized certification programs.',
    'about.p3.title': 'Innovation Ecosystem',
    'about.p3.desc': 'We create an environment for sharing experiences, developing joint R&D projects, and attracting EU grant funding.',
    // Stats
    'stats.companies': 'Participating Companies',
    'stats.countries': 'Countries of Presence',
    'stats.projects': 'Joint Projects',
    'stats.investments': 'Attracted Investments',
    // Members
    'members.title': 'Cluster Members',
    'members.desc': 'Leading technology companies and startups shaping the future of the European IT market.',
    'members.c1.desc': 'Development of payment gateways and financial tools for the B2B sector.',
    'members.c2.desc': 'Platform for big data analysis and predictive analytics.',
    'members.c3.desc': 'Cloud solutions and migration services for corporate clients.',
    'members.c4.desc': 'Innovative educational platforms for corporate training.',
    'members.c5.desc': 'Software for optimizing enterprise energy consumption.',
    'members.c6.desc': 'Comprehensive solutions for protecting corporate networks and data.',
    // Partners
    'partners.title': 'Our Partners',
    'partners.desc': 'We collaborate with leading international organizations, funds, and universities to create new opportunities.',
    'partners.t1': 'Government Organization',
    'partners.t2': 'Investment Fund',
    'partners.t3': 'Educational Partner',
    'partners.t4': 'International Association',
    'partners.t5': 'Ecosystem',
    'partners.t6': 'Regional Partner',
    'partners.t7': 'Grant Program',
    'partners.t8': 'Accelerator',
    // Projects
    'projects.title': 'Projects and Initiatives',
    'projects.desc': 'Key directions of the cluster aimed at developing the ecosystem and supporting members.',
    'projects.p1.desc': 'Cross-border digital transformation program helping companies enter new EU markets.',
    'projects.p1.status': 'Active',
    'projects.p2.desc': 'Educational initiative for training and certifying IT specialists according to European standards.',
    'projects.p2.status': 'Open for Enrollment',
    'projects.p3.desc': 'Shared R&D space for startups and corporations to test new technological hypotheses.',
    'projects.p3.status': 'In Development',
    // Events
    'events.title': 'Upcoming Events',
    'events.desc': 'Join our events for networking and experience sharing.',
    'events.e1.desc': 'Annual large-scale conference of cluster members, investors, and government representatives.',
    'events.e2.desc': 'Presentation of innovative cluster startups to European venture investors.',
    'events.e3.desc': 'Forum on the development of IT education in the EU and business integration with universities.',
    // News
    'news.title': 'News and Updates',
    'news.desc': 'Latest events, achievements, and announcements from the life of our cluster.',
    'news.all': 'All news',
    'news.read': 'Read more',
    'news.n1.title': 'Cluster received a grant from EU Digital Programme',
    'news.n1.desc': 'Funding will be directed towards developing educational initiatives and supporting early-stage startups.',
    'news.n2.title': 'New members: 5 companies joined in Q1 2026',
    'news.n2.desc': 'Welcome new cluster residents from Fintech, Cybersecurity, and EdTech sectors.',
    'news.n3.title': 'Partnership with Budapest University of Technology',
    'news.n3.desc': 'Memorandum signed on joint R&D projects and internship programs for students.',
    // Join
    'join.title': 'Join the Cluster',
    'join.desc': 'Become part of a powerful ecosystem. We are open to tech companies, startups, and educational institutions striving for growth in the European market.',
    'join.b1': 'Access to an international network of partners',
    'join.b2': 'Participation in joint projects and EU grants',
    'join.b3': 'Educational programs and mentorship',
    'join.b4': 'Promotion in the European market',
    'join.cal.title': 'Book an introductory call',
    'join.cal.select': 'Select a Date & Time',
    'join.cal.time': 'Available Times',
    'join.cal.confirm': 'Confirm Booking',
    'join.cal.success': 'Meeting booked successfully! We will send you an invitation shortly.',
    // FAQ
    'faq.title': 'Frequently Asked Questions',
    'faq.q1': 'What is the IT Cluster?',
    'faq.a1': 'The IT Cluster is an association of tech companies, startups, educational institutions, and investors created for joint development, experience sharing, and implementing large-scale projects in the EU market.',
    'faq.q2': 'Who can become a member?',
    'faq.a2': 'Members can be IT companies of any size, tech startups, universities, research centers, and investment funds that share our values and strive for development.',
    'faq.q3': 'What are the benefits of membership?',
    'faq.a3': 'Membership provides access to a closed community of partners, the opportunity to participate in EU grant programs, access to educational initiatives, joint PR, and promotion in international markets.',
    'faq.q4': 'What is the cost of participation?',
    'faq.a4': 'The cost of participation depends on the size of the company and the chosen membership package. Special preferential conditions apply to early-stage startups. A detailed price list is provided after reviewing the application.',
    'faq.q5': 'How to apply?',
    'faq.a5': 'To apply, simply book an introductory call in the "Join" section. Our manager will contact you to discuss details and next steps.',
    // Contact
    'contact.title': 'Contacts',
    'contact.email': 'Email',
    'contact.phone': 'Phone',
    'contact.office': 'Office',
    'contact.form.title': 'Write to us',
    'contact.form.name': 'Your name',
    'contact.form.email': 'Your Email',
    'contact.form.msg': 'Message...',
    'contact.form.send': 'Send',
    // Footer
    'footer.desc': 'An international digital platform uniting tech companies and innovations in the European market.',
    'footer.c1': 'Cluster',
    'footer.c2': 'Activities',
    'footer.c3': 'Information',
    'footer.rights': 'All rights reserved.'
  },
  ua: {
    // Nav
    'nav.about': 'Про нас',
    'nav.members': 'Учасники',
    'nav.projects': 'Проєкти',
    'nav.events': 'Події',
    'nav.news': 'Новини',
    'nav.contacts': 'Контакти',
    'nav.join': 'Приєднатися',
    // Hero
    'hero.title': 'Міжнародний IT Кластер',
    'hero.subtitle': 'Угорщина та країни ЄС',
    'hero.desc': "Об'єднуємо технологічні компанії, стартапи та освітні інституції для спільного зростання та інновацій на європейському ринку.",
    'hero.cta.more': 'Дізнатися більше',
    'hero.cta.join': 'Приєднатися до кластера',
    'hero.placeholder': 'Зображення / Відео',
    'hero.stat.companies': 'компаній',
    'hero.stat.countries': 'країн',
    'hero.stat.projects': 'проєктів',
    'hero.stat.events': 'подій',
    // About
    'about.title': 'Про Кластер',
    'about.desc': 'Ми — міжнародний комерційно-освітній проєкт, що працює на ринку Угорщини та країн ЄС. Наша мета — створити потужну цифрову платформу для презентації учасників, ініціатив та можливостей співпраці.',
    'about.p1.title': 'Комерційна діяльність',
    'about.p1.desc': 'Допомагаємо учасникам знаходити нових клієнтів, партнерів та виходити на нові європейські ринки через спільні ініціативи.',
    'about.p2.title': 'Освітні програми',
    'about.p2.desc': 'Розвиваємо таланти через співпрацю з університетами, організацію стажувань та спеціалізованих сертифікаційних програм.',
    'about.p3.title': 'Інноваційна екосистема',
    'about.p3.desc': 'Створюємо середовище для обміну досвідом, розробки спільних R&D проєктів та залучення грантового фінансування ЄС.',
    // Stats
    'stats.companies': 'Компаній-учасників',
    'stats.countries': 'Країн присутності',
    'stats.projects': 'Спільних проєктів',
    'stats.investments': 'Залучених інвестицій',
    // Members
    'members.title': 'Учасники Кластера',
    'members.desc': 'Провідні технологічні компанії та стартапи, що формують майбутнє європейського IT-ринку.',
    'members.c1.desc': 'Розробка платіжних шлюзів та фінансових інструментів для B2B сектору.',
    'members.c2.desc': 'Платформа для аналізу великих даних та предиктивної аналітики.',
    'members.c3.desc': 'Хмарні рішення та послуги з міграції для корпоративних клієнтів.',
    'members.c4.desc': 'Інноваційні освітні платформи для корпоративного навчання.',
    'members.c5.desc': 'Програмне забезпечення для оптимізації енергоспоживання підприємств.',
    'members.c6.desc': 'Комплексні рішення для захисту корпоративних мереж та даних.',
    // Partners
    'partners.title': 'Наші Партнери',
    'partners.desc': 'Ми співпрацюємо з провідними міжнародними організаціями, фондами та університетами для створення нових можливостей.',
    'partners.t1': 'Урядова організація',
    'partners.t2': 'Інвестиційний фонд',
    'partners.t3': 'Освітній партнер',
    'partners.t4': 'Міжнародна асоціація',
    'partners.t5': 'Екосистема',
    'partners.t6': 'Регіональний партнер',
    'partners.t7': 'Грантова програма',
    'partners.t8': 'Акселератор',
    // Projects
    'projects.title': 'Проєкти та Ініціативи',
    'projects.desc': 'Ключові напрямки роботи кластера, спрямовані на розвиток екосистеми та підтримку учасників.',
    'projects.p1.desc': 'Програма транскордонної цифрової трансформації, що допомагає компаніям виходити на нові ринки ЄС.',
    'projects.p1.status': 'Активний',
    'projects.p2.desc': 'Освітня ініціатива з підготовки та сертифікації IT-спеціалістів згідно з європейськими стандартами.',
    'projects.p2.status': 'Набір відкрито',
    'projects.p3.desc': 'Спільний R&D простір для стартапів та корпорацій для тестування нових технологічних гіпотез.',
    'projects.p3.status': 'В розробці',
    // Events
    'events.title': 'Найближчі Події',
    'events.desc': 'Долучайтеся до наших заходів для нетворкінгу та обміну досвідом.',
    'events.e1.desc': 'Щорічна масштабна конференція учасників кластера, інвесторів та представників уряду.',
    'events.e2.desc': 'Презентація інноваційних стартапів кластера для європейських венчурних інвесторів.',
    'events.e3.desc': 'Форум з питань розвитку IT-освіти в ЄС та інтеграції бізнесу з університетами.',
    // News
    'news.title': 'Новини та Оновлення',
    'news.desc': 'Останні події, досягнення та анонси з життя нашого кластера.',
    'news.all': 'Всі новини',
    'news.read': 'Читати далі',
    'news.n1.title': 'Кластер отримав грант від EU Digital Programme',
    'news.n1.desc': 'Фінансування буде спрямовано на розвиток освітніх ініціатив та підтримку стартапів на ранніх стадіях.',
    'news.n2.title': 'Нові учасники: 5 компаній приєдналися у Q1 2026',
    'news.n2.desc': 'Вітаємо нових резидентів кластера з секторів Fintech, Cybersecurity та EdTech.',
    'news.n3.title': 'Партнерство з Budapest University of Technology',
    'news.n3.desc': 'Підписано меморандум про спільні R&D проєкти та програми стажування для студентів.',
    // Join
    'join.title': 'Приєднатися до Кластера',
    'join.desc': 'Станьте частиною потужної екосистеми. Ми відкриті для технологічних компаній, стартапів та освітніх інституцій, які прагнуть розвитку на європейському ринку.',
    'join.b1': 'Доступ до міжнародної мережі партнерів',
    'join.b2': 'Участь у спільних проєктах та грантах ЄС',
    'join.b3': 'Освітні програми та менторство',
    'join.b4': 'Просування на європейському ринку',
    'join.cal.title': 'Забронювати вступний дзвінок',
    'join.cal.select': 'Оберіть дату та час',
    'join.cal.time': 'Доступний час',
    'join.cal.confirm': 'Підтвердити бронювання',
    'join.cal.success': 'Зустріч успішно заброньовано! Ми надішлемо вам запрошення найближчим часом.',
    // FAQ
    'faq.title': 'Часті Запитання',
    'faq.q1': 'Що таке IT Кластер?',
    'faq.a1': "IT Кластер — це об'єднання технологічних компаній, стартапів, освітніх закладів та інвесторів, створене для спільного розвитку, обміну досвідом та реалізації масштабних проєктів на ринку ЄС.",
    'faq.q2': 'Хто може стати учасником?',
    'faq.a2': 'Учасниками можуть стати IT-компанії будь-якого розміру, технологічні стартапи, університети, дослідницькі центри та інвестиційні фонди, які поділяють наші цінності та прагнуть розвитку.',
    'faq.q3': 'Які переваги членства?',
    'faq.a3': 'Членство надає доступ до закритої спільноти партнерів, можливість участі у грантових програмах ЄС, доступ до освітніх ініціатив, спільний PR та просування на міжнародних ринках.',
    'faq.q4': 'Яка вартість участі?',
    'faq.a4': 'Вартість участі залежить від розміру компанії та обраного пакету членства. Для стартапів на ранніх стадіях діють спеціальні пільгові умови. Детальний прайс надається після розгляду заявки.',
    'faq.q5': 'Як подати заявку?',
    'faq.a5': 'Для подачі заявки достатньо забронювати вступний дзвінок у розділі "Приєднатися". Наш менеджер зв\'яжеться з вами для обговорення деталей та наступних кроків.',
    // Contact
    'contact.title': 'Контакти',
    'contact.email': 'Email',
    'contact.phone': 'Телефон',
    'contact.office': 'Офіс',
    'contact.form.title': 'Напишіть нам',
    'contact.form.name': "Ваше ім'я",
    'contact.form.email': 'Ваш Email',
    'contact.form.msg': 'Повідомлення...',
    'contact.form.send': 'Надіслати',
    // Footer
    'footer.desc': "Міжнародна цифрова платформа, що об'єднує технологічні компанії та інновації на європейському ринку.",
    'footer.c1': 'Кластер',
    'footer.c2': 'Діяльність',
    'footer.c3': 'Інформація',
    'footer.rights': 'Усі права захищені.'
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const t = (key: string) => {
    return translations[language][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-347">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}